__webpack_require__.p = "/curriculum/";